import { render, staticRenderFns } from "./DispensationTab.vue?vue&type=template&id=2728bcce&scoped=true&"
import script from "./DispensationTab.vue?vue&type=script&lang=ts&"
export * from "./DispensationTab.vue?vue&type=script&lang=ts&"
import style0 from "./DispensationTab.vue?vue&type=style&index=0&id=2728bcce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2728bcce",
  null
  
)

export default component.exports